import type { TypePolicies } from '@apollo/client/cache';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      // Echter Feldname: der Cache ignoriert den Alias `exhibits`
      exhibits_connection: {
        keyArgs: ['filters'],
        merge: (existing = { data: [] }, incoming) => {
          return {
            ...incoming,
            data: [...existing.data, ...incoming.data]
          }
        },
      }
    }
  },
};
